import React, { FC } from 'react';

import { BaseSidebar, SidebarNavItem } from './BaseSidebar';
import { CommunitySidebar } from './CommunitySidebar';
import { DirectMessagingSidebar } from './DirectMessagingSidebar';

// eslint-disable-next-line no-shadow
export enum SidebarType {
  COMMUNITY = 'community',
  DMS = 'dms',
}

interface SidebarProps {
  type?: SidebarType;
  navItems?: SidebarNavItem[];
}

export const Sidebar = ({ type, navItems }: SidebarProps) => {
  const TYPE_TO_SIDEBAR = {
    community: CommunitySidebar,
    dms: DirectMessagingSidebar,
  };

  const Element: FC<SidebarProps> = TYPE_TO_SIDEBAR[type || ''] || BaseSidebar;

  return <Element navItems={navItems || []} />;
};

export default Sidebar;
